module.exports = __webpack_public_path__ + "img/meal-management-en.f181ac59.png";